import React from "react";

import Lamina17img from "../images/lamina17img.png";
import Lamina17fondo from "../images/lamina17fondo.png";
import Lamina17nota from "../images/lamina17nota.png";
import Lamina17group from "../images/lamina17group.png";
import Lamina17actividad from "../images/lamina17actividad.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import TitleSmall from "../components/TitleSmall";
import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  blue: {
    color: theme.palette.blue.main,
    borderColor: theme.palette.blue.main,
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    "& h1": {
      textAlign: "left",
    },
    [theme.breakpoints.down("md")]: {
      "& img": {
        maxWidth: "100% !important",
      },
    },
  },
  actividadFondo: {
    backgroundImage: "url(" + Lamina17fondo + ")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    minHeight: 500,
    width: "100%",
    marginTop: -240,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    marginBottom: "4em",
    [theme.breakpoints.down("xs")]: {
      marginTop: 0,
      minHeight: 300,
      backgroundSize: "100% auto",
      backgroundPosition: "bottom",
      justifyContent: "flex-start",
      "& p": {
        maxWidth: "100%",
      },
    },
  },
  rectangleYellow: {
    backgroundColor: "#ffcb05",
    padding: "5px 15px 5px 0",
    transform: "rotate(-5deg)",
    fontWeight: 500,
    margin: "0 2em 2em 0",
    maxWidth: 300,
    "& ul": {
      paddingLeft: 30,
      marginTop: 0,
    },
    "& p": {
      paddingLeft: "1em",
      margin: 0,
    },
  },
}));

const Lamina17 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 17: Emergencias, solidaridad y prevención"
        meta={[
          {
            property: "og:title",
            content: "Lámina 17: Emergencias, solidaridad y prevención",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "Una emergencia es una situación que pone en peligro la vida de las personas y puede afectar el bienestar de una comunidad.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="17" color="blue" />

      <Container maxWidth="md" className={classes.contentLamina}>
        <Title title="Emergencias, solidaridad y prevención" color="blue" />
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <Actividad color="blue" />
            <p>
              <strong>Lee el diálogo y conversa con algún familiar.</strong>
            </p>
            <p>
              ¿Puede ser un problema que las casas se construyan en el borde de
              los ríos? ¿Por qué?
            </p>
            <br></br>
            <p style={{ color: "#ef4136" }}>
              <strong>
                Una emergencia es una situación que pone en peligro la vida de
                las personas y puede afectar el bienestar de una comunidad, por
                ejemplo, cuando ocurre un accidente, una enfermedad, un fenómeno
                climático o una epidemia.
              </strong>
            </p>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <img src={Lamina17img} alt="Emergencias" />
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <img src={Lamina17nota} alt="Nota" />

        <div className={classes.actividadFondo}>
          <div className={classes.rectangleYellow}>
            <p>Reflexiona:</p>
            <ul>
              <li>
                ¿Qué crees que pasó con las personas que vivían en esas casas?
              </li>
              <li>¿Cómo se pudo evitar esta situación?</li>
            </ul>
          </div>
        </div>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root2}
          spacing={2}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <TitleSmall title="LA IMPORTANCIA DE LA SOLIDARIDAD" color="blue" />
            <p>
              En situaciones de emergencia es importante que ayudemos a los más
              afectados. Muchas veces requieren de agua, víveres, medicina,
              ropa, frazadas u otros artículos de primera necesidad. La ayuda
              suele llegar desde el Estado, pero todos los miembros de la
              sociedad civil podemos ayudar mientras dure la emergencia.
            </p>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <img src={Lamina17group} alt="Actividad" />
          </Grid>
        </Grid>
        <TitleSmall title="LA IMPORTANCIA DE LA PREVENCIÓN" color="blue" />
        <p>
          Para evitar emergencias y reducir el impacto de los fenómenos
          naturales, es importante ser precavidos. Una forma de serlo es adaptar
          nuestras viviendas y barrios o comunidades a las características del
          clima y del territorio.
        </p>
        <p>
          <strong>Une cada enunciado con la imagen que describe.</strong>
        </p>
        <img src={Lamina17actividad} alt="Actividad" />
        <p>
          Estos son buenos ejemplos de cómo debemos adaptarnos al clima y al
          territorio para vivir de manera segura.
        </p>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-17.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          classes={{ root: classes.blue }}
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 17: Emergencias, solidaridad y prevención'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="Valores para la convivencia en familia"
        anteriorEnlace="/lamina-1-16"
        siguiente="Las distintas formas de ser peruano"
        siguienteEnlace="/lamina-1-18"
      />
    </>
  );
};

export default Lamina17;
